var ezdia;
(function (ezdia) {
    /**
     * This function is to support old code
     * TODO: REMOVE THIS
     * @param param
     */
    function oldUserProps(user) {
        var _a = user || {}, allAccountsExceptExpertMgt = _a.all_accounts_except_expert_mgt, CONTEXT_ROOT = _a.context_root, deskUrl = _a.desk_url, email = _a.email, fullUrl = _a.full_url, HOME_INSTANCE = _a.home_instance, userId = _a.id, isAdmin = _a.is_admin, logo = _a.logo, userName = _a.name, onlyTool = _a.only_tool, orgAdmin = _a.org_admin, orgEmailFooter = _a.org_email_footer, orgLabel = _a.org_label;
        return {
            allAccountsExceptExpertMgt: allAccountsExceptExpertMgt,
            CONTEXT_ROOT: CONTEXT_ROOT,
            deskUrl: deskUrl,
            email: email,
            fullUrl: fullUrl,
            HOME_INSTANCE: HOME_INSTANCE,
            userId: userId,
            isAdmin: isAdmin,
            logo: logo,
            userName: userName,
            onlyTool: onlyTool,
            orgAdmin: orgAdmin,
            orgEmailFooter: orgEmailFooter,
            orgLabel: orgLabel
        };
    }
    function updateUrlParams(param) {
        var url = new URL(window.location.href);
        var searchParams = url.searchParams;
        searchParams.delete(param);
        window.location.href = url.toString();
    }
    function handelCookieClear() {
        var type = this.dataset.type;
        var d = new Date();
        d.setTime(d.getTime());
        var expires = "expires=" + d.toUTCString();
        document.cookie = type + "=;path=/;" + expires;
        updateUrlParams(type);
    }
    function developerMode() {
        var _a;
        var _b = ezdia.CONST.DEV_COOKIE_KEYS, DEBUG = _b.DEBUG, TEST = _b.TEST;
        var _c = __read(ezdia.util.getUrlParams([
            DEBUG,
            TEST
        ]), 2), isUrlParamDebug = _c[0], isUrlParamTest = _c[1];
        var cokkiesSet = new Set();
        if (isUrlParamDebug) {
            document.cookie = DEBUG + "=" + isUrlParamDebug + ";path=/;";
        }
        if (isUrlParamTest) {
            document.cookie = TEST + "=" + isUrlParamTest + ";path=/;";
        }
        (_a = document.cookie.split(';')) === null || _a === void 0 ? void 0 : _a.forEach(function (cookie) {
            var _a = __read(cookie.split('='), 2), name = _a[0], value = _a[1];
            var trimName = name.trim();
            var trimValue = value.trim();
            if (trimName === DEBUG && trimValue === 'true') {
                cokkiesSet.add(DEBUG);
            }
            else if (trimName === TEST && trimValue === 'prodb') {
                cokkiesSet.add(TEST);
            }
        });
        if (cokkiesSet.size) {
            var id = ezdia.util.makeId();
            var htmlContent = ezdia.templates.app.developer(id, cokkiesSet);
            $("body").append(htmlContent);
            $("#" + id).find('button').on('click', handelCookieClear);
        }
    }
    ezdia.developerMode = developerMode;
    // eslint-disable-next-line import/prefer-default-export
    function render() {
        return __awaiter(this, void 0, void 0, function () {
            var renderMethod, _a, pageType, data, response, navigation, user, pageParams, message, redirect, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        renderMethod = ezdia.route();
                        if (!renderMethod) {
                            return [2 /*return*/];
                        }
                        _a = ezdia.util.getUrlParamsAsObj(), pageType = _a.pageType, data = __rest(_a, ["pageType"]);
                        return [4 /*yield*/, ezdia.Http.post({
                                url: pageType + ".htm?api=true&v=1",
                                data: data
                            })];
                    case 1:
                        response = _b.sent();
                        navigation = response.navigation, user = response.user, pageParams = response.page_params, message = response.message, redirect = response.redirect;
                        ezdia.config.user = __assign({}, user);
                        ezdia.config.pageParams = __assign({}, pageParams);
                        ezdia.config.message = message;
                        ezdia.config.redirect = redirect;
                        // TODO: OLD CODE SUPPORT
                        $.ezdia.config.pageParams = __assign(__assign({}, ezdia.config.pageParams), oldUserProps(user));
                        ezdia.component.navbar.render(navigation);
                        renderMethod();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        console.error(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    ezdia.render = render;
})(ezdia || (ezdia = {}));
document.addEventListener('readystatechange', function () {
    var readyState = document.readyState;
    if (readyState === 'interactive') {
        ezdia.developerMode();
        ezdia.render();
    }
});
